import React from 'react';
import { InputText } from 'primereact/inputtext';
import DataType from '../types/DataType.js';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

const CellEditor = ({ column, options }) => {
    return React.createElement("div", { className: "w-full" }, renderEditor());
    function renderEditor() {
        switch (column.dataType) {
            case DataType.Boolean:
                return (React.createElement(Dropdown, { className: "w-full", onChange: (e) => { var _a; return (_a = options.editorCallback) === null || _a === void 0 ? void 0 : _a.call(options, e.target.value); }, options: [
                        { label: "True", value: true },
                        { label: "False", value: false },
                    ], optionLabel: "label", optionValue: "value", showOnFocus: true, value: options.value }));
            case DataType.DateTime:
                return (React.createElement(Calendar, { className: "w-full", onChange: (e) => { var _a; return (_a = options.editorCallback) === null || _a === void 0 ? void 0 : _a.call(options, e.value); }, showTime: column.parts !== "date", timeOnly: column.parts === "time", value: options.value }));
            case DataType.Number:
                return (React.createElement(InputNumber, { className: "w-full", onChange: (e) => { var _a; return (_a = options.editorCallback) === null || _a === void 0 ? void 0 : _a.call(options, e.value); }, value: options.value }));
            case DataType.Text:
                return (React.createElement(InputText, { className: "w-full", onChange: (e) => { var _a; return (_a = options.editorCallback) === null || _a === void 0 ? void 0 : _a.call(options, e.target.value); }, value: options.value }));
            case DataType.Uuid:
                return (React.createElement(InputText, { className: "w-full", onChange: (e) => { var _a; return (_a = options.editorCallback) === null || _a === void 0 ? void 0 : _a.call(options, e.target.value); }, value: options.value }));
            default:
                return null;
        }
    }
};

export { CellEditor as default };
//# sourceMappingURL=CellEditor.js.map
